import classnames from 'classnames';
import {
  Tooltip as FloatTooltip,
  TooltipContent,
  TooltipTrigger,
} from './controls';
import IconTooltip from '../../assets/icons/icon_tooltip_grey_20.svg?react';
import './index.scss';

export const Tooltip = ({ icon, className, renderContent }) => (
  <FloatTooltip>
    <TooltipTrigger className={classnames('tooltip_trigger', className)}>
      {icon || <IconTooltip />}
    </TooltipTrigger>
    <TooltipContent className="tooltip_content">
      {renderContent()}
    </TooltipContent>
  </FloatTooltip>
);
